"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageUploadInputSchema = void 0;
exports.default = ImageUploadInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const utils_1 = require("@mui/utils");
const CameraAltOutlined_1 = __importDefault(require("@mui/icons-material/CameraAltOutlined"));
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.imageUploadInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: typeof window === 'undefined' ? zod_1.z.any() : zod_1.z.instanceof(File, { message: 'This is required' }),
    notRequired: zod_1.z.any(),
});
function ImageUploadInput({ name, primaryText, secondaryText, formHelperText }) {
    var _a;
    const { control } = (0, react_hook_form_1.useFormContext)();
    const [thumbnail, setThumbnail] = (0, react_1.useState)('');
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    const handleImageChange = (e) => {
        if (e.target.files) {
            field.onChange(e.target.files[0]);
            const imageUrl = URL.createObjectURL(e.target.files[0]);
            setThumbnail(imageUrl);
        }
    };
    (0, react_1.useEffect)(() => {
        return () => {
            // cleanup to release memory https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL_static#memory_management
            URL.revokeObjectURL(thumbnail);
        };
    }, [thumbnail]);
    (0, react_1.useEffect)(() => {
        if (!field.value) {
            setThumbnail('');
        }
    }, [field.value]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: thumbnail ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: thumbnail, alt: "thumbnail", width: "100%", height: "auto" }), (0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", justifyContent: "center", children: (0, jsx_runtime_1.jsxs)(material_1.Button, { component: "label", children: [(0, jsx_runtime_1.jsx)(material_1.Input, Object.assign({ sx: utils_1.visuallyHidden, type: "file", inputProps: { accept: 'image/*', capture: 'environment' } }, field, { value: '', onChange: handleImageChange })), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "buttonLabel", color: "text.interactive", children: "Replace Photo" })] }) })] })) : ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, error: !!error, children: [(0, jsx_runtime_1.jsxs)(material_1.Button, { component: "label", variant: "outlined", disableTouchRipple: true, fullWidth: true, sx: {
                        paddingTop: '3rem',
                        paddingBottom: '3rem',
                        color: error ? 'error.dark' : 'text.interactive',
                        borderColor: error ? 'error.dark' : 'text.interactive',
                    }, children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "column", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, children: (0, jsx_runtime_1.jsx)(CameraAltOutlined_1.default, { sx: { color: error && 'error.dark' }, fontSize: "large" }) }), primaryText && ((0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "bodyMediumSemiBold", color: "text.tertiary", children: primaryText }) })), secondaryText && ((0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "lowestLevelBook", color: "text.tertiary", children: secondaryText }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Input, Object.assign({ sx: utils_1.visuallyHidden, type: "file", inputProps: { accept: 'image/*', capture: 'environment' } }, field, { value: '', onChange: handleImageChange }))] }), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : formHelperText }) })] })) }));
}
//# sourceMappingURL=ImageUploadInput.js.map